/**
 * 会員情報
 */
export default {
  namespaced: true,
  state: {
    byId: {
      0: '',
      1: 'ビートレンド',
    },
  },
}
